const categoryAlternativePlacement = {
  SalonRecurso: 1,
  SalonEspecialSEP: 2,
  SalonEspecialSEM: 3,
  Hogar: 4,
  Itinerante: 5,
  SalonRegular: 6
};

export default categoryAlternativePlacement;
